import MicOffOutline from './MicOffOutline'

export default MicOffOutline
// eslint-disable-next-line import/export
export * from './MicOffOutline'
